<!-- Login template -->
<template>
  <v-app>
    <v-container fill-height>
      <v-layout class="align-center justify-center">
        <v-flex xs12 sm8 md4>
          <v-form>
            <v-alert :value="true" dense outlined type="error" v-if="error">
              {{ msg }}
            </v-alert>
            <v-card class="elevation-5">
              <v-toolbar dark color="blue">
                <v-toolbar-title>
                  {{ $t('login.login_form') }}
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  prepend-icon="mdi-account"
                  :label="$t('login.email')"
                  type="text"
                  v-model="email"
                ></v-text-field>
                <v-text-field
                  prepend-icon="mdi-lock"
                  :label="$t('login.password')"
                  type="password"
                  v-model="current_password"
                  autocomplete="off"
                ></v-text-field>
              </v-card-text>
              <v-divider light></v-divider>
              <v-card-actions>
                <v-btn rounded color="indigo" dark to="register">{{
                  $t('login.register')
                }}</v-btn>
                <v-spacer></v-spacer>
                <v-btn rounded color="primary" dark @click.prevent="login">
                  <v-icon left>mdi-pencil</v-icon>
                  {{ $t('login.login') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>
<script>
import AuthenticationService from '@/services/AuthenticationService.js';
export default {
  data() {
    return {
      email: '',
      current_password: '',
      message: '',
      error: false,
    };
  },
  // Check if user is logged in
  created() {
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/main');
    }
  },

  methods: {
    //When login putton is pressed
    async login() {
      try {
        const credentials = {
          userEmail: this.email,
          userPassword: this.current_password,
        };
        const response = await AuthenticationService.login(credentials);
        this.message = response.message;
        if (response.error) {
          this.error = response.error;
        }
        //talleta arvot storeen
        this.$store.dispatch('setToken', response.data.token);
        this.$store.dispatch('setUser', response.data.user);
        console.log('täällä');
        // this.$router.replace('/main');
      } catch (error) {
        this.message = error.response.data.message;
      }
    },
  },
};
</script>
